import React from 'react';

export const Ripple = ({ x, y }) => {
  const style = {
    left: `${x}px`,
    top: `${y}px`,
  };

  return <div className="ripple" style={style} />;
};
